/* Cuadernito: movimiento, oferta y carrusel */
(function () {
  'use strict';
  var root = document.documentElement;
  var quieto = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Oferta vencida: oculta todo lo de la oferta aunque la página venga de caché */
  function revisarOferta() {
    var fin = parseInt(root.getAttribute('data-cdn-oferta-fin') || '0', 10);
    if (fin && Date.now() / 1000 >= fin) root.classList.add('cdn-vencida');
  }

  /* Aparecer al hacer scroll */
  var obsReveal = 'IntersectionObserver' in window ? new IntersectionObserver(function (entradas) {
    entradas.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('is-in'); obsReveal.unobserve(e.target); }
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 }) : null;

  function initReveal(scope) {
    scope.querySelectorAll('[data-cdn-reveal]:not(.is-in)').forEach(function (el) {
      if (!obsReveal || quieto) { el.classList.add('is-in'); return; }
      obsReveal.observe(el);
    });
  }

  /* Números que cuentan */
  function contar(el) {
    var txt = el.getAttribute('data-cdn-contar') || el.textContent;
    var n = parseInt(String(txt).replace(/\D/g, ''), 10);
    if (!n || quieto) return;
    var t0 = null, dur = 1200;
    function paso(t) {
      if (!t0) t0 = t;
      var k = Math.min(1, (t - t0) / dur);
      var e = 1 - Math.pow(1 - k, 3);
      el.textContent = String(Math.round(n * e));
      if (k < 1) requestAnimationFrame(paso); else el.textContent = txt;
    }
    el.textContent = '0';
    requestAnimationFrame(paso);
  }
  var obsContar = 'IntersectionObserver' in window ? new IntersectionObserver(function (entradas) {
    entradas.forEach(function (e) {
      if (e.isIntersecting) { contar(e.target); obsContar.unobserve(e.target); }
    });
  }, { threshold: 0.6 }) : null;
  function initContar(scope) {
    if (!obsContar) return;
    scope.querySelectorAll('[data-cdn-contar]').forEach(function (el) {
      if (el.dataset.cdnListo) return;
      el.dataset.cdnListo = '1';
      obsContar.observe(el);
    });
  }

  /* Cuenta regresiva */
  var relojes = [];
  function dos(n) { return n < 10 ? '0' + n : String(n); }
  function tic() {
    var ahora = Date.now() / 1000;
    relojes.forEach(function (r) {
      var falta = Math.max(0, Math.floor(r.fin - ahora));
      var d = Math.floor(falta / 86400), h = Math.floor(falta % 86400 / 3600), m = Math.floor(falta % 3600 / 60), s = falta % 60;
      if (r.d) r.d.textContent = dos(d);
      if (r.h) r.h.textContent = dos(h);
      if (r.m) r.m.textContent = dos(m);
      if (r.s) r.s.textContent = dos(s);
      if (falta === 0) root.classList.add('cdn-vencida');
    });
  }
  function initCuenta(scope) {
    scope.querySelectorAll('[data-cdn-fin]').forEach(function (el) {
      if (el.dataset.cdnListo) return;
      el.dataset.cdnListo = '1';
      relojes.push({
        fin: parseInt(el.getAttribute('data-cdn-fin'), 10),
        d: el.querySelector('[data-u="d"]'), h: el.querySelector('[data-u="h"]'),
        m: el.querySelector('[data-u="m"]'), s: el.querySelector('[data-u="s"]')
      });
    });
    tic();
  }
  setInterval(tic, 1000);

  /* Carrusel de páginas */
  function initCarrusel(scope) {
    scope.querySelectorAll('[data-cdn-carrusel]').forEach(function (c) {
      if (c.dataset.cdnListo) return;
      c.dataset.cdnListo = '1';
      var pista = c.querySelector('.cdn-hojas__pista');
      if (!pista) return;
      function ancho() { var li = pista.querySelector('li'); return li ? li.getBoundingClientRect().width + 18 : 300; }
      function mover(dir) {
        var fin = pista.scrollLeft + pista.clientWidth >= pista.scrollWidth - 8;
        if (dir > 0 && fin) pista.scrollTo({ left: 0, behavior: quieto ? 'auto' : 'smooth' });
        else pista.scrollBy({ left: dir * ancho(), behavior: quieto ? 'auto' : 'smooth' });
      }
      c.querySelectorAll('[data-dir]').forEach(function (b) {
        b.addEventListener('click', function () { pausa = true; mover(parseInt(b.getAttribute('data-dir'), 10)); });
      });
      var pausa = false, visible = false;
      ['pointerenter', 'focusin', 'touchstart'].forEach(function (ev) { c.addEventListener(ev, function () { pausa = true; }, { passive: true }); });
      c.addEventListener('pointerleave', function () { pausa = false; });
      if ('IntersectionObserver' in window) new IntersectionObserver(function (e) { visible = e[0].isIntersecting; }, { threshold: 0.4 }).observe(c);
      if (!quieto) setInterval(function () { if (visible && !pausa && !document.hidden) mover(1); }, 3200);
    });
  }

  /* Ver una página más grande */
  function initZoom(scope) {
    scope.querySelectorAll('[data-cdn-zoom]').forEach(function (b) {
      if (b.dataset.cdnListo) return;
      b.dataset.cdnListo = '1';
      b.addEventListener('click', function () {
        var sec = b.closest('section') || document;
        var dlg = sec.querySelector('[data-cdn-zoom-dialog]');
        if (!dlg || typeof dlg.showModal !== 'function') { window.open(b.getAttribute('data-cdn-zoom'), '_blank'); return; }
        var img = dlg.querySelector('img');
        img.src = b.getAttribute('data-cdn-zoom');
        img.alt = b.getAttribute('data-cdn-pie') || '';
        dlg.querySelector('.cdn-zoom__pie').textContent = b.getAttribute('data-cdn-pie') || '';
        dlg.showModal();
      });
    });
    scope.querySelectorAll('[data-cdn-zoom-dialog]').forEach(function (dlg) {
      if (dlg.dataset.cdnListo) return;
      dlg.dataset.cdnListo = '1';
      dlg.addEventListener('click', function (e) { if (e.target === dlg) dlg.close(); });
    });
  }

  /* Barra de compra fija */
  function initBarra() {
    var barra = document.querySelector('[data-cdn-barra]');
    if (!barra || barra.dataset.cdnListo) return;
    barra.dataset.cdnListo = '1';
    barra.hidden = false;
    var pie = document.querySelector('footer, .footer');
    var pieVisible = false;
    if (pie && 'IntersectionObserver' in window) new IntersectionObserver(function (e) { pieVisible = e[0].isIntersecting; actualizar(); }).observe(pie);
    function actualizar() {
      var ver = window.scrollY > window.innerHeight * 0.9 && !pieVisible;
      barra.classList.toggle('is-visible', ver);
      document.body.classList.toggle('cdn-con-barra', ver);
    }
    window.addEventListener('scroll', actualizar, { passive: true });
    actualizar();
  }

  /* Inclinación de las tapas con el mouse */
  function initTilt(scope) {
    if (quieto || !window.matchMedia('(pointer: fine)').matches) return;
    scope.querySelectorAll('.cdn-tilt').forEach(function (el) {
      if (el.dataset.cdnListo) return;
      el.dataset.cdnListo = '1';
      el.addEventListener('pointermove', function (e) {
        var r = el.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width - 0.5, y = (e.clientY - r.top) / r.height - 0.5;
        el.style.transform = 'perspective(800px) rotateY(' + (x * 14) + 'deg) rotateX(' + (-y * 12) + 'deg) scale(1.03)';
      });
      el.addEventListener('pointerleave', function () { el.style.transform = ''; });
    });
  }


  /* Carrito: los botones de compra agregan al carrito lateral (así ve la propuesta del plan fundador) */
  function cajon() {
    var d = document.querySelector('cart-drawer');
    return d && typeof d.renderContents === 'function' && window.routes ? d : null;
  }
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-cdn-agregar]');
    if (!a) return;
    var d = cajon();
    if (!d) return;
    e.preventDefault();
    if (a.getAttribute('aria-disabled') === 'true') return;
    a.setAttribute('aria-disabled', 'true');
    a.classList.add('is-cargando');
    var fd = new FormData();
    fd.append('id', a.getAttribute('data-cdn-agregar'));
    fd.append('quantity', '1');
    fd.append('sections', d.getSectionsToRender().map(function (s) { return s.id; }).join(','));
    fd.append('sections_url', window.location.pathname);
    fetch(window.routes.cart_add_url, { method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' }, body: fd })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.status) { window.location.href = a.href; return; }
        d.classList.remove('is-empty');
        d.renderContents(data);
      })
      .catch(function () { window.location.href = a.href; })
      .finally(function () { a.removeAttribute('aria-disabled'); a.classList.remove('is-cargando'); });
  });

  /* Propuesta del plan fundador dentro del carrito lateral: cambia sin salir de la página */
  document.addEventListener('submit', function (e) {
    var f = e.target.closest && e.target.closest('form[data-cdn-upsell]');
    if (!f) return;
    var d = f.closest('cart-drawer') ? cajon() : null;
    if (!d) return;
    e.preventDefault();
    var updates = {};
    new FormData(f).forEach(function (v, k) { var m = k.match(/^updates\[(\d+)\]$/); if (m) updates[m[1]] = parseInt(v, 10); });
    var btn = f.querySelector('button');
    if (btn) { btn.disabled = true; btn.classList.add('is-cargando'); }
    fetch(window.routes.cart_update_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates: updates, sections: d.getSectionsToRender().map(function (s) { return s.id; }), sections_url: window.location.pathname })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (!data.sections) { f.submit(); return; }
        d.renderContents({ id: parseInt(f.getAttribute('data-cdn-plan'), 10), sections: data.sections });
      })
      .catch(function () { f.submit(); });
  });

  function init(scope) {
    scope = scope || document;
    revisarOferta();
    initReveal(scope); initContar(scope); initCuenta(scope);
    initCarrusel(scope); initZoom(scope); initTilt(scope); initBarra();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
